import Vue from "vue";
import Vuetify, { VIcon } from "vuetify/lib";
//import DaySpanVuetify from 'dayspan-vuetify'

// import 'vuetify/dist/vuetify.min.css'
//import 'material-design-icons-iconfont/dist/material-design-icons.css'
//import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  components: {
    VIcon
  }
});

export default new Vuetify({
  icons: {
    iconfont: "fa" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    themes: {
      dark: false,
      light: {
        primary: "#1E88E5",
        secondary: "#64B5F6",
        accent: "#9c27b0",
        error: "#f44336",
        warning: "#ffeb3b",
        info: "#2196f3",
        success: "#4caf50",
        highlight: "#E91E63"
      }
    }
  },
  options: {
    customProperties: true
  }
});
/*
Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});*/
